import React, { useEffect, useState } from "react";
const axios = require("axios");
const constants = require("../../../constant");

export default function Supportform() {
    const [adminUserEmail, setadminUserEmail] = useState(null);
    const [loading, setloading] = useState(true);
    const [showError, setshowError] = useState(false);
    const [query, setquery] = useState({
        subject: "",
        message: "",
    });
    useEffect(async () => {
        const result = await axios.get(
            `${constants.backendUrl}/getAdminUserEmail`,
            {
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
                params: {
                    token: localStorage.getItem("token"),
                },
            }
        );
        if (result.data.success) {
            setadminUserEmail(result.data.email);
            console.log(result.data.email);
            setloading(false);
        } else {
            setloading(false);
            setshowError(true);
        }
    }, []);
    useState(() => {}, [loading]);
    return (
        <div>
            <div className="main-container">
                <div className="min-height-200px">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <div className="title">
                                    <h4>Support</h4>
                                </div>
                                <nav aria-label="breadcrumb" role="navigation">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href="/dashboard">Home</a>
                                        </li>
                                        <li
                                            className="breadcrumb-item active"
                                            aria-current="page"
                                        >
                                            Support
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div className="page-header">
                        {!loading ? (
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <form>
                                        <div className="form-group row">
                                            <label className="col-sm-12 col-md-2 col-form-label">
                                                Email
                                            </label>
                                            <div className="col-sm-12 col-md-10">
                                                <input
                                                    className="form-control"
                                                    value={adminUserEmail}
                                                    disabled
                                                    type="email"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-12 col-md-2 col-form-label">
                                                Subject
                                            </label>
                                            <div className="col-sm-12 col-md-10">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder="Problem/Query"
                                                    value={query.subject}
                                                    onChange={(e) => {
                                                        setquery({
                                                            ...query,
                                                            subject:
                                                                e.target.value,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-12 col-md-2 col-form-label">
                                                Subject
                                            </label>
                                            <div className="col-sm-12 col-md-10">
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Problem/Query Description"
                                                    value={query.message}
                                                    onChange={(e) => {
                                                        setquery({
                                                            ...query,
                                                            message:
                                                                e.target.value,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-12 col-md-2 col-form-label"></label>
                                            <div className="col-sm-12 col-md-10">
                                                <input
                                                    className="btn btn-primary"
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    onClick={async (e) => {
                                                        e.preventDefault();
                                                        const result =
                                                            await axios.post(
                                                                `${constants.backendUrl}/teachersupport`,
                                                                {
                                                                    email: adminUserEmail,
                                                                    subject:
                                                                        query.subject,
                                                                    message:
                                                                        query.message,
                                                                    token: localStorage.getItem(
                                                                        "token"
                                                                    ),
                                                                }
                                                            );
                                                        if (
                                                            result.data.success
                                                        ) {
                                                            alert("Query Sent");
                                                        } else {
                                                            alert(
                                                                result.data.message
                                                            );
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        ) : (
                            <div className="row">
                                <h1>Loading...</h1>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
